export enum HgUnitsOfMeasurement {
  M = 'M',
  M2 = 'M2',
  M3 = 'M3',
  KG = 'KG',
  KGM2 = 'KGM2',
  PERCENT = 'PERCENT',
}
